import { Oura, ShoppingCartV3 } from '@jouzen/ecom-components';
import { cx } from 'class-variance-authority';
import Link from 'next/link';
import { useRouter } from 'next/navigation';
import { useLocale, useTranslations } from 'next-intl';
import { useCallback } from 'react';

import { RingModelEnum } from '@/app/enums/RingModelEnum';

import type { HeaderProps } from './types';

const MobileHeader = ({
  hasEyebrow,
  inverseHeader,
  isAccessory,
  isOuraRing4Wizard,
  itemCountForIcon,
  opacity,
}: HeaderProps): JSX.Element => {
  const t = useTranslations();
  const locale = useLocale();
  const router = useRouter();
  const transparent = (opacity ?? 0) < 0.1;

  const handleShoppingCartClick = useCallback(() => {
    router.push(`/${locale}/cart`);
  }, [locale, router]);

  return (
    <header
      className="fixed z-20 h-14 w-full"
      style={{ top: hasEyebrow ? '3rem' : '0' }}
    >
      <div
        className={cx('z-10 flex w-full justify-between', {
          'border-b border-gray-300': opacity === 1,
          'border-none': opacity !== 1,
        })}
        style={{
          background: `rgba(254, 250, 239, ${opacity})`,
        }}
      >
        <Link
          aria-label={t('pdp_back_to_pop')}
          className={cx('block p-4', {
            'text-sandstone-200': inverseHeader && transparent,
            'text-sandstone-500': !inverseHeader || !transparent,
          })}
          data-cy="nav_logo_link"
          href={`/product/rings/${!isOuraRing4Wizard && !isAccessory ? RingModelEnum.Gen3 : ''}`}
        >
          <Oura width={64} />
        </Link>
        <div className="flex">
          <ShoppingCartV3
            hiddenHamburger={false}
            inverseHeader={
              (inverseHeader && transparent) ?? (!inverseHeader || !transparent)
            }
            onShoppingCartClick={handleShoppingCartClick}
            shoppingCartCount={itemCountForIcon ?? 0}
          />
        </div>
      </div>
    </header>
  );
};

export default MobileHeader;
